import Names from '../router/names';
import store from '../store';

export const isAuth = ({ next, router }) => {
	const token = store.getters['token'];
	if (!token) {
		return router.push({ name: Names.Login });
	}

	return next();
};

export const isNotAuth = ({ next, router }) => {
	const token = store.getters['token'];
	if (token) {
		return router.push({ name: Names.Home });
	}

	return next();
};
